import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { Oval } from "react-loader-spinner";

export default function ViewOrder({
  showView,
  closeModal,
  refreshPage,
  order,
}) {
  const handleClose = () => {
    closeModal();
  };

  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true); 

      if (order) {
        try {
          const response = await axiosInstance.get("/user/order/get_order_no_paginate", {
            params: {
              order_code: order.order_code, // Fetch orders with the same order_code
            },
          });

          setOrderList(response.data.data.orders); // Adjust based on your API response structure
        } catch (error) {
          console.error("Error fetching orders:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchOrders();
  }, [order]);

  const capitalize = (text) => {
    if (!text) return "";
    return text
      .replace("_", " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const orderDetails = orderList.length > 0 ? (
    orderList.map((orderInfo, index) => (
      
      <Card className="mb-3" key={index}>
        <Card.Body>
          <Card.Text>
            <strong>Company Name:</strong> {orderInfo.company_name}
            <br />
            <strong>Product Name:</strong> {orderInfo.product_name}
            <br />
            <strong>Category:</strong> {orderInfo.category_name}
            <br />
            <strong>Sub-Category:</strong> {orderInfo.sub_category_name}
            <br />
            <strong>Price:</strong> {orderInfo.price}
            <br />
            <strong>Quantity:</strong> {orderInfo.quantity}
            <br />
            <strong>Total Price:</strong> {orderInfo.total_price}
            <br />
            <strong>Payment Type:</strong> {orderInfo.payment_type && orderInfo.payment_type === "cash" ? "Cash/Prepaid" : orderInfo.payment_type}
            <br />
            <strong>WareHouse Name:</strong> {orderInfo.ware_house_name}
            <br />

            <strong>Order Code:</strong> {orderInfo.order_code}
            <br />
            <strong>Sales-Supervisor Status:</strong>{" "}
            {orderInfo.status === "active" ? (
              <span className="badge bg-success">{orderInfo.status}</span>
            ) : (
              <span className="badge bg-info">{orderInfo.status}</span>
            )}

            {["finance", "chain_supply"].map((role, index) => {
              // find the first approved record for this role
              const record = orderInfo.requisitions?.find(
                (req) =>
                  req.approved_as === role &&
                  req.status !== "pending" &&
                  req.approved_by
              );

              return (
                <div key={index}>
                  <span>
                    {capitalize(role)}:{" "}
                    {record
                      ? `${record.approved_by.first_name} ${record.approved_by.last_name}`
                      : ""}
                  </span>{" "}
                  {record ? (
                    <span className="badge bg-success">Approved</span>
                  ) : (
                    <span className="badge bg-warning text-dark">Pending</span>
                  )}
                </div>
              );
            })}

            {/* {orderInfo.requisitions
              ?.filter(req => req.status !== "pending" && req.approved_by) 
              .map((req, index) => (
                <div key={index}>
                  <span>
                    {req.approved_by.first_name} {req.approved_by.last_name}
                  </span>{" "}
                  <span className="badge bg-success">Approved</span>
                </div>
              ))} */}
          </Card.Text>
        </Card.Body>
      </Card>
    ))
  ) : (
    <p>No order details available.</p>
  );

  return (
    <div className="ViewTransaction">
      <Modal show={showView} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Order Details</Modal.Title>
        </Modal.Header>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "80vh" }}
          >
            <Oval
              height={80}
              width={80}
              color="#FF0200"
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#4fa94d"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </div>
        ) : (
        <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
          {loading ? <p>Loading...</p> : orderDetails}
        </Modal.Body>
      )}

        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#c4281b", border: "none" }}
            onClick={refreshPage}
          >
            Refresh
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
